import React, { Suspense, lazy, useEffect } from "react";
import PropTypes from "prop-types";
import AppBar from "@material-ui/core/AppBar";
import CssBaseline from "@material-ui/core/CssBaseline";
import Divider from "@material-ui/core/Divider";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import IconButton from "@material-ui/core/IconButton";
import HomeIcon from "@material-ui/icons/Home";
import List from "@material-ui/core/List";
import "./App.css";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import MenuIcon from "@material-ui/icons/Menu";
import Toolbar from "@material-ui/core/Toolbar";
import LoyaltyIcon from "@material-ui/icons/Loyalty";
import Typography from "@material-ui/core/Typography";
import { AnimatedSwitch } from "react-router-transition";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import {
  BrowserRouter as Router,
  Route,
  Link,
  NavLink,
} from "react-router-dom";
import VideoCallIcon from "@material-ui/icons/VideoCall";
import ExploreIcon from "@material-ui/icons/Explore";
import EmailIcon from "@material-ui/icons/Email";
import CommentIcon from "@material-ui/icons/Comment";
import LiveHelpIcon from "@material-ui/icons/LiveHelp";
import MenuBookIcon from "@material-ui/icons/MenuBook";
import DateRangeIcon from "@material-ui/icons/DateRange";
import AssistantIcon from "@material-ui/icons/Assistant";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import CallIcon from "@material-ui/icons/Call";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import ConfirmationNumberIcon from "@material-ui/icons/ConfirmationNumber";
import { BookmarkBorderOutlined } from "@material-ui/icons";
const Listkatalog = lazy(() => import("./Components/Listkatalog"));
const Home = lazy(() => import("./Components/Home"));
const Video = lazy(() => import("./Components/VideoPage"));
const Sejarah = lazy(() => import("./Components/Sejarah"));
const Detailevent = lazy(() => import("./Components/Detailevent"));
const live = lazy(() => import("./live"));
const NoMatch = lazy(() => import("./Components/NoMatch"));
const Inputkatalog = lazy(() => import("./Components/Inputkatalog"));
const JadwalPage = lazy(() => import("./Components/JadwalPage"));
const DetaileventPage = lazy(() => import("./Components/DetaileventPage"));
const Warta = lazy(() => import("./Components/Warta"));
const Selisip = lazy(() => import("./Components/Selisip"));
const Detailrenungan = lazy(() => import("./Components/Detailrenungan"));
const Detailselisip = lazy(() => import("./Components/Detailselisip"));
const QRCODE = lazy(() => import("./Components/QRCODE"));
const Tiket = lazy(() => import("./Components/Tiket"));
const QRCODEAFTER = lazy(() => import("./Components/QRCODEAFTER"));
const GEMASS = lazy(() => import("./Components/GEMASS"));
const EBOOK = lazy(() => import("./Components/EBOOK"));
const katalogInput = lazy(() => import("./Components/katalogInput"));
const Gudang = lazy(() => import("./Components/Gudang"));
const VerifikasiTiket = lazy(() => import("./Components/VerifikasiTiket"));
const Login = lazy(() => import("./Components/Login"));

const drawerWidth = 270;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  drawer: {
    [theme.breakpoints.up("sm")]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  appBar: {
    [theme.breakpoints.up("sm")]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
    backgroundColor: "#1e2837",
  },
  content: {
    flexGrow: 1,
  },
}));

function App(props) {
  const { window } = props;
  const classes = useStyles();
  const theme = useTheme();
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [home, setHome] = React.useState("selected");
  const [sejarah, setSejarah] = React.useState("");
  const [warta, setWarta] = React.useState("");
  const [gemass, setGemass] = React.useState("");
  const [selisip, setSelisip] = React.useState("");
  const [jadwal, setJadwal] = React.useState("");
  const [video, setVideo] = React.useState("");
  const [tiket, setTiket] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [katalog, setKatalog] = React.useState("");
  const [wa, setWA] = React.useState("");
  const [ebook, setEbook] = React.useState("");
  const [tel, setTel] = React.useState("");
  const [alamat, setAlamat] = React.useState("");

 
  const meta = {
    title: "GKI Layur",
    description:
      "Beribadah kepada Tuhan bersama sama dengan jemaat Tuhan yang lain, memuji dan memuliakan nama-Nya, serta belajar bertumbuh bersama di dalam Tuhan Yesus",
    canonical: "https://gkilayur.web.app/",
    meta: {
      charset: "utf-8",
      name: {
        keywords:
          "GKI Layur,gkilayur,gki layur,layur,ibadah minggu,ibadah,gki jakarta,gki,gereja di jakarta, gereja jakarta",
      },
    },
  };
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const handleHome = () => {
    setHome("selected");
    setSejarah("");
    setWarta("");
    setGemass("");
    setSelisip("");
    setJadwal("");
    setTiket("");
    setVideo("");
    setEmail("");
    setWA("");
    setTel("");
    setAlamat("");
    setKatalog("");
    setEbook("");
  };
  const handleSejarah = () => {
    setHome("");
    setSejarah("selected");
    setWarta("");
    setGemass("");
    setSelisip("");
    setJadwal("");
    setTiket("");
    setVideo("");
    setEmail("");
    setWA("");
    setTel("");
    setAlamat("");
    setKatalog("");
    setEbook("");
  };
  const handleWarta = () => {
    setHome("");
    setSejarah("");
    setWarta("selected");
    setGemass("");
    setSelisip("");
    setJadwal("");
    setTiket("");
    setVideo("");
    setEmail("");
    setWA("");
    setTel("");
    setAlamat("");
    setKatalog("");
    setEbook("");
  };
  const handleGemass = () => {
    setHome("");
    setSejarah("");
    setWarta("");
    setGemass("selected");
    setSelisip("");
    setJadwal("");
    setTiket("");
    setVideo("");
    setEmail("");
    setWA("");
    setTel("");
    setAlamat("");
    setKatalog("");
    setEbook("");
  };
  const handleSelisip = () => {
    setHome("");
    setSejarah("");
    setWarta("");
    setGemass("");
    setJadwal("");
    setSelisip("selected");
    setTiket("");
    setVideo("");
    setEmail("");
    setWA("");
    setTel("");
    setAlamat("");
    setKatalog("");
    setEbook("");
  };
  const handleJadwal = () => {
    setHome("");
    setSejarah("");
    setWarta("");
    setGemass("");
    setSelisip("");
    setJadwal("selected");
    setVideo("");
    setEmail("");
    setWA("");
    setTel("");
    setAlamat("");
    setKatalog("");
    setEbook("");
  };
  const handleVideo = () => {
    setHome("");
    setSejarah("");
    setWarta("");
    setGemass("");
    setSelisip("");
    setJadwal("");
    setTiket("");
    setVideo("selected");
    setEmail("");
    setWA("");
    setTel("");
    setAlamat("");
    setKatalog("");
    setEbook("");
  };
  const handleTiket = () => {
    setHome("");
    setSejarah("");
    setWarta("");
    setGemass("");
    setSelisip("");
    setJadwal("");
    setTiket("selected");
    setVideo("");
    setEmail("");
    setWA("");
    setTel("");
    setAlamat("");
    setKatalog("");
    setEbook("");
  };
  const handleEmail = () => {
    setHome("");
    setSejarah("");
    setWarta("");
    setGemass("");
    setSelisip("");
    setJadwal("");
    setTiket("");
    setVideo("");
    setEmail("selected");
    setWA("");
    setTel("");
    setAlamat("");
    setKatalog("");
    setEbook("");
  };
  const handleWA = () => {
    setHome("");
    setSejarah("");
    setWarta("");
    setGemass("");
    setSelisip("");
    setJadwal("");
    setTiket("");
    setVideo("");
    setEmail("");
    setWA("selected");
    setTel("");
    setAlamat("");
    setKatalog("");
    setEbook("");
  };
  const handleTel = () => {
    setHome("");
    setSejarah("");
    setWarta("");
    setGemass("");
    setSelisip("");
    setJadwal("");
    setTiket("");
    setVideo("");
    setEmail("");
    setWA("");
    setTel("selected");
    setAlamat("");
    setKatalog("");
    setEbook("");
  };
  const handleAlamat = () => {
    setHome("");
    setSejarah("");
    setWarta("");
    setGemass("");
    setSelisip("");
    setJadwal("");
    setTiket("");
    setVideo("");
    setEmail("");
    setWA("");
    setTel("");
    setAlamat("selected");
    setKatalog("");
    setEbook("");
  };
  const handleKatalog = () => {
    setHome("");
    setSejarah("");
    setWarta("");
    setGemass("");
    setSelisip("");
    setJadwal("");
    setTiket("");
    setVideo("");
    setEmail("");
    setWA("");
    setTel("");
    setAlamat("");
    setKatalog("selected");
    setEbook("");
  };

  const handleEbook = () => {
    setHome("");
    setSejarah("");
    setWarta("");
    setGemass("");
    setSelisip("");
    setJadwal("");
    setTiket("");
    setVideo("");
    setEmail("");
    setWA("");
    setTel("");
    setAlamat("");
    setKatalog("");
    setEbook("selected");
  };

  const drawer = (
    <div
      style={{
        backgroundColor: "#1e2837",
      }}
    >
      <div
        style={{
          minHeight: 56,
          justifyContent: "center",
          paddingTop: 16,
          paddingBottom: 15,
        }}
      >
        <Typography
          variant="h6"
          noWrap
          style={{
            width: "100%",
            fontWeight: "bold",
            textAlign: "center",
            color: "white",
          }}
        >
          GKI LAYUR
        </Typography>
      </div>

      <Divider light />
      <List
        style={{
          backgroundColor: "#18202c",
          color: "white",
          fontWeight: "bold",
        }}
      >
        <NavLink
          to="/"
          activeClassName="is-active"
          style={{
            textDecoration: "none",
          }}
        >
          <ListItem
            button
            key="Dashboard"
            onClick={handleHome}
            style={{
              backgroundColor: home === "" ? "" : "#009be5",
            }}
          >
            <ListItemIcon>
              <HomeIcon style={{ color: "white", fontSize: 20 }} />
            </ListItemIcon>
            <Typography
              style={{
                textAlign: "center",
                color: "white",
                fontSize: 14,
                fontWeight: "bold",
              }}
            >
              Home
            </Typography>
          </ListItem>
        </NavLink>
        <Link
          to="/sejarah"
          style={{
            textDecoration: "none",
            color: "black",
            alignItems: "center",
          }}
        >
          <ListItem
            button
            key="Video"
            onClick={handleSejarah}
            style={{
              backgroundColor: sejarah === "" ? "" : "#009be5",
            }}
          >
            <ListItemIcon>
              <MenuBookIcon style={{ color: "white", fontSize: 20 }} />
            </ListItemIcon>
            <Typography
              style={{
                textAlign: "center",
                color: "white",
                fontSize: 14,
                fontWeight: "bold",
              }}
            >
              Sejarah
            </Typography>
          </ListItem>
        </Link>
        <Link
          to="/warta"
          style={{
            textDecoration: "none",
            color: "black",
            alignItems: "center",
          }}
        >
          <ListItem
            button
            key="Video"
            onClick={handleWarta}
            style={{
              backgroundColor: warta === "" ? "" : "#009be5",
            }}
          >
            <ListItemIcon>
              <CommentIcon style={{ color: "white", fontSize: 20 }} />
            </ListItemIcon>
            <Typography
              style={{
                textAlign: "center",
                color: "white",
                fontSize: 14,
                fontWeight: "bold",
              }}
            >
              Warta Jemaat
            </Typography>
          </ListItem>
        </Link>
        <Link
          to="/gemass"
          style={{
            textDecoration: "none",
            color: "black",
            alignItems: "center",
          }}
        >
          <ListItem
            button
            key="Video"
            onClick={handleGemass}
            style={{
              backgroundColor: gemass === "" ? "" : "#009be5",
            }}
          >
            <ListItemIcon>
              <AssistantIcon style={{ color: "white", fontSize: 20 }} />
            </ListItemIcon>
            <Typography
              style={{
                textAlign: "center",
                color: "white",
                fontSize: 14,
                fontWeight: "bold",
              }}
            >
              GEMASS
            </Typography>
          </ListItem>
        </Link>
        <Link
          to="/selisip"
          style={{
            textDecoration: "none",
            color: "black",
            alignItems: "center",
          }}
        >
          <ListItem
            button
            key="Video"
            onClick={handleSelisip}
            style={{
              backgroundColor: selisip === "" ? "" : "#009be5",
            }}
          >
            <ListItemIcon>
              <LiveHelpIcon style={{ color: "white", fontSize: 20 }} />
            </ListItemIcon>
            <Typography
              style={{
                textAlign: "center",
                color: "white",
                fontSize: 14,
                fontWeight: "bold",
              }}
            >
              Selisip
            </Typography>
          </ListItem>
        </Link>
        <Link
          to="/jadwal"
          style={{
            textDecoration: "none",
            color: "black",
            alignItems: "center",
          }}
        >
          <ListItem
            button
            key="Video"
            onClick={handleJadwal}
            style={{
              backgroundColor: jadwal === "" ? "" : "#009be5",
            }}
          >
            <ListItemIcon>
              <DateRangeIcon style={{ color: "white", fontSize: 20 }} />
            </ListItemIcon>
            <Typography
              style={{
                textAlign: "center",
                color: "white",
                fontSize: 14,
                fontWeight: "bold",
              }}
            >
              Info Layur
            </Typography>
          </ListItem>
        </Link>
        <Link
          to="/ebook"
          style={{
            textDecoration: "none",
            color: "black",
            alignItems: "center",
          }}
        >
          <ListItem
            button
            key="Video"
            onClick={handleEbook}
            style={{
              backgroundColor: ebook === "" ? "" : "#009be5",
            }}
          >
            <ListItemIcon>
              <BookmarkBorderOutlined
                style={{ color: "white", fontSize: 20 }}
              />
            </ListItemIcon>
            <Typography
              style={{
                textAlign: "center",
                color: "white",
                fontSize: 14,
                fontWeight: "bold",
              }}
            >
              eBook
            </Typography>
          </ListItem>
        </Link>
        <Link
          to="/video"
          style={{
            textDecoration: "none",
            color: "black",
            alignItems: "center",
          }}
        >
          <ListItem
            button
            key="Video"
            onClick={handleVideo}
            style={{
              backgroundColor: video === "" ? "" : "#009be5",
            }}
          >
            <ListItemIcon>
              <VideoCallIcon style={{ color: "white", fontSize: 20 }} />
            </ListItemIcon>
            <Typography
              style={{
                textAlign: "center",
                color: "white",
                fontSize: 14,
                fontWeight: "bold",
              }}
            >
              Video
            </Typography>
          </ListItem>
        </Link>
        <Link
          to="/katalog"
          style={{
            textDecoration: "none",
            color: "black",
            alignItems: "center",
          }}
        >
          <ListItem
            button
            key="Video"
            onClick={handleKatalog}
            style={{
              backgroundColor: katalog === "" ? "" : "#009be5",
            }}
          >
            <ListItemIcon>
              <LoyaltyIcon style={{ color: "white", fontSize: 20 }} />
            </ListItemIcon>
            <Typography
              style={{
                textAlign: "center",
                color: "white",
                fontSize: 14,
                fontWeight: "bold",
              }}
            >
              LapakLayur
            </Typography>
          </ListItem>
        </Link>
        <ListItem button key="Transaksi">
          <Typography
            style={{
              textAlign: "center",
              color: "white",
              fontSize: 17,
              fontWeight: "bold",
            }}
          >
            Getting Closer
          </Typography>
        </ListItem>
        <Link
          to="/Tiket"
          style={{
            textDecoration: "none",
            color: "black",
            alignItems: "center",
          }}
        >
          <ListItem
            button
            key="Tiket"
            onClick={handleTiket}
            style={{
              backgroundColor: tiket === "" ? "" : "#ff641a",
            }}
          >
            <ListItemIcon>
              <ConfirmationNumberIcon
                style={{
                  color: tiket === "" ? "#ff641a" : "white",
                  fontSize: 20,
                }}
              />
            </ListItemIcon>
            <Typography
              style={{
                textAlign: "center",
                color: "white",
                fontSize: 14,
                fontWeight: "bold",
              }}
            >
              Tiket Kehadiran
            </Typography>
          </ListItem>
        </Link>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="mailto:gki_layur@yahoo.com"
          style={{
            textDecoration: "none",
            color: "black",
            alignItems: "center",
          }}
        >
          <ListItem
            button
            key="Katalog"
            onClick={handleEmail}
            style={{
              backgroundColor: email === "" ? "" : "#009be5",
            }}
          >
            <ListItemIcon>
              <EmailIcon style={{ color: "white", fontSize: 20 }} />
            </ListItemIcon>
            <Typography
              style={{
                textAlign: "center",
                color: "white",
                fontSize: 14,
                fontWeight: "bold",
              }}
            >
              Email Kami
            </Typography>
          </ListItem>
        </a>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://api.whatsapp.com/send?phone=+6281386786098"
          style={{
            textDecoration: "none",
            color: "black",
            alignItems: "center",
          }}
        >
          <ListItem
            button
            key="Katalog"
            onClick={handleWA}
            style={{
              backgroundColor: wa === "" ? "" : "#009be5",
            }}
          >
            <ListItemIcon>
              <WhatsAppIcon style={{ color: "white", fontSize: 20 }} />
            </ListItemIcon>
            <Typography
              style={{
                textAlign: "center",
                color: "white",
                fontSize: 14,
                fontWeight: "bold",
              }}
            >
              Whatsapp Kami
            </Typography>
          </ListItem>
        </a>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="tel:+62813-86786098"
          style={{
            textDecoration: "none",
            color: "black",
            alignItems: "center",
          }}
        >
          <ListItem
            button
            key="Katalog"
            onClick={handleTel}
            style={{
              backgroundColor: tel === "" ? "" : "#009be5",
            }}
          >
            <ListItemIcon>
              <CallIcon style={{ color: "white", fontSize: 20 }} />
            </ListItemIcon>
            <Typography
              style={{
                textAlign: "center",
                color: "white",
                fontSize: 14,
                fontWeight: "bold",
              }}
            >
              Telepon Kami
            </Typography>
          </ListItem>
        </a>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://goo.gl/maps/myXy1qVycHZUdd9L6"
          style={{
            textDecoration: "none",
            color: "black",
            alignItems: "center",
          }}
        >
          <ListItem
            button
            key="Katalog"
            onClick={handleAlamat}
            style={{
              backgroundColor: alamat === "" ? "" : "#009be5",
            }}
          >
            <ListItemIcon>
              <ExploreIcon style={{ color: "white", fontSize: 20 }} />
            </ListItemIcon>
            <Typography
              style={{
                textAlign: "center",
                color: "white",
                fontSize: 14,
                fontWeight: "bold",
              }}
            >
              Alamat Kami
            </Typography>
          </ListItem>
        </a>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://play.google.com/store/apps/details?id=com.gkilayur.gkilayur&hl=en_US"
          style={{
            textDecoration: "none",
            color: "black",
            alignItems: "center",
          }}
        >
          <ListItem
            button
            key="Download"
            style={{
              backgroundColor: "#ff004f",
            }}
          >
            <ListItemIcon>
              <PlayArrowIcon style={{ color: "white", fontSize: 20 }} />
            </ListItemIcon>
            <Typography
              style={{
                textAlign: "center",
                color: "white",
                fontSize: 12,
                fontWeight: "bold",
              }}
            >
              Download GKI Layur App
            </Typography>
          </ListItem>
        </a>
        {/* <Link
          to="/transaksi"
          style={{
            textDecoration: "none",
            color: "black",
            alignItems: "center",
          }}
        >
          <ListItem button key="Transaksi">
            <ListItemIcon>
              <FormatListBulletedIcon
                style={{ color: "white", fontSize: 20 }}
              />
            </ListItemIcon>
            <Typography
              style={{
                textAlign: "center",
                color: "white",
                fontSize: 14,
                fontWeight: "bold",
              }}
            >
              Cetak Data
            </Typography>
          </ListItem>
        </Link> */}
      </List>
    </div>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <Router>
      <div className={classes.root}>
        <CssBaseline />
        <AppBar
          position="fixed"
          className={classes.appBar}
          style={{
            backgroundColor: "#009be5",
          }}
        >
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              className={classes.menuButton}
            >
              <MenuIcon />
            </IconButton>
            <Typography
              variant="h8"
              noWrap
              style={{
                width: "100%",
                fontWeight: "bold",
                textAlign: "right",
              }}
            >
              #TERUSBERTUMBUH
            </Typography>
          </Toolbar>
        </AppBar>
        <nav className={classes.drawer} aria-label="mailbox folders">
          {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
          <Hidden smUp implementation="css">
            <Drawer
              container={container}
              variant="temporary"
              anchor={theme.direction === "rtl" ? "right" : "left"}
              open={mobileOpen}
              onClose={handleDrawerToggle}
              classes={{
                paper: classes.drawerPaper,
              }}
              ModalProps={{
                keepMounted: true, // Better open performance on mobile.
              }}
            >
              {drawer}
            </Drawer>
          </Hidden>
          <Hidden xsDown implementation="css">
            <Drawer
              classes={{
                paper: classes.drawerPaper,
              }}
              variant="permanent"
              open
            >
              {drawer}
            </Drawer>
          </Hidden>
        </nav>
        <main className={classes.content}>
          <Suspense
            fallback={
              <div style={{ height: 1000, backgroundColor: "#d3d3d3" }}></div>
            }
          >
            <div className={classes.toolbar} />
            <AnimatedSwitch
              atEnter={{ opacity: 0 }}
              atLeave={{ opacity: 0 }}
              atActive={{ opacity: 1 }}
              className="switch-wrapper"
            >
              <Route exact path="/">
                <Home />
              </Route>
              <Route exact path="/katalog">
                <Listkatalog />
              </Route>
              <Route exact path="/video">
                <Video />
              </Route>
              <Route exact path="/Tiket">
                <Tiket />
              </Route>
              <Route exact path="/sejarah">
                <Sejarah />
              </Route>
              <Route exact path="/jadwal">
                <JadwalPage />
              </Route>
              <Route exact path="/gemass">
                <GEMASS />
              </Route>
              <Route exact path="/warta">
                <Warta />
              </Route>
              <Route exact path="/selisip">
                <Selisip />
              </Route>
              <Route exact path="/ebook">
                <EBOOK />
              </Route>
              <Route exact path="/detailevent/:id" component={Detailevent} />
              <Route exact path="/selisip/:id" component={Detailselisip} />
              <Route exact path="/live/:id" component={live} />
              <Route exact path="/QRCODEAFTER/:id" component={QRCODEAFTER} />
              <Route exact path="/QRCODE/:id" component={QRCODE} />
              <Route exact path="/renungan/:id" component={Detailrenungan} />
              <Route exact path="/@dm1nP@n3l" component={Login} />
              <Route exact path="/asd" component={Inputkatalog} />
              <Route exact path="/kataloginput" component={katalogInput} />
              <Route exact path="/gudang" component={Gudang} />
              <Route
                exact
                path="/VerifikasiTiket"
                component={VerifikasiTiket}
              />
              <Route
                exact
                path="/detaileventPage/:id"
                component={DetaileventPage}
              />
              <Route component={NoMatch} />
            </AnimatedSwitch>
          </Suspense>
        </main>
      </div>
    </Router>
  );
}

App.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

export default App;
